import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content", "icon"]

  toggle() {
    const isExpanded = this.triggerTarget.getAttribute("aria-expanded") === "true"
    this.triggerTarget.setAttribute("aria-expanded", String(!isExpanded))
    this.contentTarget.classList.toggle("hidden")
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-90")
    }
  }
}
